<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "Home",
  components: {
    //
  },
  data() {
    return {
      auth_user: "",
      user: null,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    let type = this.user.type;
    let role = this.user.user_role;
    let job_title = this.user.job_title;
    if (type == "client") {
      this.$router.push("/client-dashboard");
    }
    if (type == "hmo") {
      this.$router.push("/hmo-dashboard");
    }
    if (type == "employee" && role == 0) {
      this.$router.push("/employee-dashboard");
    }
    if (type == "provider") {
      this.$router.push("/provider-dashboard");
    }

    if (type == "employee" && job_title == 'dashboard') {
      this.$router.push("/dashboard-view");
    }

    if (type == "shis" || (type == "employee" && role == 1 && job_title != 'dashboard')) {
      this.$router.push("/state-dashboard");
    }

    if (type == "tpa") {
      this.$router.push("/tpa-dashboard");
    }
    if (type == "tpa_employee") {
      this.$router.push("/tpa-employee-dashboard");
    }

    if (type == "provider_employee") {
      this.$router.push("/personnel");
    }

    if (type == "vendor_employee" || type == "vendor_staff") {
      this.$router.push("/vendor-employee-dashboard");
    }

    if (job_title == "M and E") {
      this.$router.push("/qa-dashboard");
    }

    if (job_title == "Authorization Code") {
      this.$router.push("/authorization-code-statistics");
    }

    if (job_title == "Claims Vetter" || job_title == "Claims Verifier") {
      this.$router.push("/claims-statistics");
    }

    this.$router.go();
  },

  mounted() {
    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
  },

  methods: {
    //
  },
  created() {
    //
  },
};
</script>
